import styled from 'styled-components';

const BundleDetailsCardsWrapperStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 28px 10px;
  gap: 3px;
`;

const BundleDetailsCardContainerStyled = styled.div`
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0px 2px 4px rgba(56, 20, 81, 0.15);
  cursor: pointer;
  width: 33%;
`;

const BundleDetailsCardTitleStyled = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  min-height: 20px;
  p {
    font-size: 12px;
    color: #7c6c8a;
    margin-left: 3px;
  }
`;

const BundleDetailsCardPromoStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 18px;

  h5 {
    color: #7c6c8a;
    font-size: 14px;
    line-height: 16px;
  }

  h2 {
    color: #e92070;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
  }
  h4 {
    color: #553e65;
    font-size: 14px;
    font-weight: 600;
  }
`;

const BundleDetailsCheckIconStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 18px;
  margin-bottom: 13px;
`;

const BundleDetailsDisclaimerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 20px;
  h3 {
    color: #553e65;
    font-size: 16px;
    line-height: 24px;
    padding-left: 20px;
  }
  h3 span {
    font-weight: 600;
  }
`;

const BundleDetailsModalWrapperStyled = styled.div`
  position: fixed;
  z-index: 99;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 500px;
`;

const BundleDetailsModalCardStyled = styled.div`
  background: white;
  padding: 15px 25px 25px;
  border-radius: 8px 8px 0px 0px;
  margin: auto;
  box-shadow: rgba(56, 20, 81, 0.15) 0px 2px 4px;
  text-align: center;
`;

const BundleDetailsModalCardTitleStyled = styled.span`
  color: #553e65;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  strong {
    font-weight: 500;
  }
`;

const BundleDetailsModalCardContentStyled = styled.div`
  width: 100%;
  margin-top: 9px;
  border-top: 2px dashed #ccc4d2;
  padding-top: 8px;
  h2 {
    color: #e92070;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    margin-bottom: 5px;
  }
  p {
    margin-bottom: 4px;
    color: #553e65;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }
`;

const BundleDetailsModalCardButtonsStyled = styled.div`
  width: 100%;
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const OverlayStyled = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9;
  visibility: visible;
`;

export {
  BundleDetailsCardsWrapperStyled,
  BundleDetailsCardContainerStyled,
  BundleDetailsCardTitleStyled,
  BundleDetailsCardPromoStyled,
  BundleDetailsCheckIconStyled,
  BundleDetailsDisclaimerStyled,
  BundleDetailsModalWrapperStyled,
  BundleDetailsModalCardStyled,
  BundleDetailsModalCardTitleStyled,
  BundleDetailsModalCardContentStyled,
  BundleDetailsModalCardButtonsStyled,
  OverlayStyled,
};
